// src/components/hand-tile/index.js
export { default as HandTile } from './HandTile';